import React from "react";

export const UpArrow = () => {
  return (
    <span className="fa-stack">
      <i className="fa fa-sort-up fa-stack-1x" aria-hidden="true"></i>
      <i className="fa fa-sort fa-stack-1x" aria-hidden="true"></i>
    </span>
  );
}

export const DownArrow = () => {
  return (
    <span className="fa-stack">
      <i className="fa fa-sort-down fa-stack-1x" aria-hidden="true"></i>
      <i className="fa fa-sort fa-stack-1x" aria-hidden="true"></i>
    </span>
  );
}

export const DefaultArrow = () => {
  return (
    <span className="fa-stack">
      <i className="fa fa-sort fa-stack-1x" aria-hidden="true"></i>
    </span>
  )
}
